import { Avatar, SxProps, alpha, useTheme } from '@mui/material';

interface ProfileIconProps {
  name?: string;
  size?: number;
  onClick?: any;
  sx?: SxProps;
}

export default function ProfileIcon({
  name,
  size = 32,
  onClick,
  sx
}: ProfileIconProps) {
  const theme = useTheme();

  function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function nameAvatar({
    name,
    canClick,
    sx
  }: {
    name?: string;
    canClick: boolean;
    sx?: SxProps;
  }) {
    const string = name || 'Backspace User';
    const bgcolor = name
      ? stringToColor(string)
      : theme.palette.action.disabled;

    return {
      sx: {
        width: size,
        height: size,
        fontFamily: 'Oswald',
        fontSize: size / 2,
        bgcolor,
        cursor: canClick ? 'pointer' : undefined,
        '&:hover, &.Mui-focusVisible': {
          bgcolor: canClick ? alpha(bgcolor, 0.7) : bgcolor
        },
        ...sx
      },
      children: `${string.split(' ')[0][0]}${string.split(' ')[1][0]}`
    };
  }

  return (
    <Avatar
      {...nameAvatar({ name, canClick: Boolean(onClick), sx })}
      onClick={onClick}
    />
  );
}
